import { build_response_error, is_success_status } from "./one_chat_websocket_helpers";

export function parse_socket_payload(event) {
  return JSON.parse(event.data);
}

export function is_response_payload(payload = {}) {
  return payload.type === "response" && Boolean(payload.request_id);
}

export function resolve_pending_response(pending_requests, payload = {}) {
  const pending = pending_requests.get(payload.request_id);
  if (!pending) return;

  window.clearTimeout(pending.timeout);
  pending_requests.delete(payload.request_id);

  if (is_success_status(payload.status)) {
    pending.resolve(payload.data);
    return;
  }

  pending.reject(build_response_error(payload));
}

export function reject_pending_requests(pending_requests, error) {
  pending_requests.forEach((pending) => {
    window.clearTimeout(pending.timeout);
    pending.reject(error);
  });
  pending_requests.clear();
}
